import { AxiosError } from 'axios';

export function getErrorMessage(error: Error): string {
    if (error instanceof AxiosError) {
        const statusCode = error.response?.status;
        switch (statusCode) {
            case 503:
                return "Wait a bit and refresh the page";
            case 401:
                return "Log out and back in";
            default:
                return "You found a new error, let me know how you did it";
        }
    } else {
        return "AAAAHHHHHHHH";
    }
}
